import { Injectable } from '@angular/core';
import { HTTPService } from '../../shared/services/http.service';
import { LibraryAsset } from '../models/library-asset';
import { LibraryAssetResult } from '../models/library-asset-result';

@Injectable()
export class AssetService {
  private _assets:LibraryAsset[];
  private _tags:string[];
  constructor(private _dac$http: HTTPService) { }

  getAsset(assetId:number) : Promise<LibraryAsset>{
    return this._dac$http.get("/library-assets/" + assetId).then(resp => {
      let result = resp.json() as any;
      let asset = new LibraryAsset();
      Object.assign(asset, result);
      return asset;
    
    });
  }

  getAssetResult(resultId:string) : Promise<LibraryAssetResult> {
    return this._dac$http.get("/library-asset-results/" + resultId).then(resp => {
      let jsonResult = resp.json() as any;
      let serverResult = new LibraryAssetResult();
      let serverAsset = new LibraryAsset();
      Object.assign(serverResult, jsonResult);
      if (jsonResult.asset) {
        Object.assign(serverAsset, jsonResult.asset);
        serverResult.asset = serverAsset;
      }
      return serverResult;
    });
  }

  saveAssetResult(result:LibraryAssetResult) {
    // let's limit the info that is sent up
    let resultToSave = Object.assign(new LibraryAssetResult(), result);
    let asset = new LibraryAsset();
    asset.id = result.asset.id;
    resultToSave.asset = asset;
    return this._dac$http.post("/library-asset-results/", resultToSave).then(resp => {
      let jsonResult = resp.json() as any;
      let serverResult = new LibraryAssetResult();
      let serverAsset = new LibraryAsset();
      Object.assign(serverResult, jsonResult);
      if (jsonResult.asset) {
        Object.assign(serverAsset, jsonResult.asset);
      }
      return serverResult;
    });
  }

  getAssets() :Promise<LibraryAsset[]>{
    if (this._assets) {
      return Promise.resolve(this._assets);
    }

    return this._dac$http.get("/library-assets/").then(resp => {
      let result = resp.json() as any;
      let assets:LibraryAsset[] = [];
      if (result.length) {
        assets = result.map(r => {
          let asset = new LibraryAsset();
          Object.assign(asset, r);
          return asset;
        });
      }
      this._assets = assets;
      return assets;
    });
  }

  searchAssets(searchString:string, selectedTag:string, assetType:'All'|'article'|'assignment'|null) {
    return this.getAssets().then(assets => {
      assets = assets || [];
      if (assetType && assetType != 'All') {
        assets = assets.filter(a => a.type == assetType);
      }
      if (selectedTag && selectedTag !='All') {
        assets= assets.filter(a => a.hasTag(selectedTag));  
      }
      if (searchString && searchString.trim() !="") {
        assets = assets.filter(a => a.titleContainsString(searchString.trim()));
      }
      return assets;
    });
  }

  getTags() : Promise<string[]>{
    if (this._tags) {
      return Promise.resolve(this._tags);
    }
    return this._dac$http.get("/tags/").then(resp => {
      let results = resp.json() as string[];
      this._tags = results;
      return results;
    });
  }

  getAssetsByType(type:'article'|'exercise') : Promise<LibraryAsset[]> {
    return this.getAssets().then(assets => {
      return assets.filter(a => a.type == type);
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/library-assets/services/asset.service.ts